module.exports = __webpack_public_path__ + "img/b_Rentrit_front_3.f782f07c.jpeg";